import React from 'react';

import { Grid } from '@material-ui/core';

import { FrontpageCard } from '@klp/design/FrontPageCard/FrontpageCard';

import type { FrontpageCardTypes } from '../utils';
import type { FrontpageCardItem } from './frontpageCardsConfig';

interface FrontpageCardWrapperProps {
    cardType: FrontpageCardTypes;
    config: FrontpageCardItem;
}

export const FrontpageCardWrapper: React.FC<FrontpageCardWrapperProps> = ({
    cardType,
    config,
}) => {
    // Don't render if not visible
    if (!config.isVisible()) {
        return null;
    }

    return (
        <Grid item={true} xs={12} sm={6} md={6} lg={3} key={cardType}>
            <FrontpageCard
                title={config.title}
                icon={config.icon}
                data-testid={config.dataTestId}
                visible={config.isVisible()}
            >
                {config.content}
            </FrontpageCard>
        </Grid>
    );
};
